module.exports = __webpack_public_path__ + "img/product_46.af4ef7d.webp";